import React from 'react'
import * as C from "../componentsM/index";

const SocietiesAndClub = () => {
    return (
        <>

            <C.Hero title={"SOCIETIES AND CLUBS"} image={"/hero/18.jpg"} />

            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                    <p>All students, from both the Primary and High School sections, are encouraged to initiate and join various societies and clubs. This list is not exhaustive.</p>

                    <h1 className='font-semibold'>TIS MUN</h1>

                    <p>This simulation will introduce students to the workings of United Nations. Through participation in a Model UN simulation, students will learn to understand the actual consequences of international politics, to solve real problems, to compromise, and to see the world from different perspectives. The issues provided in this simulation allow the students to research and debate topics of international importance.</p>

                    <h1 className='font-semibold'>TIS Drama Club</h1>


                    <p> The Drama Club activities include poetry readings, writing workshops and performances which culminate in the TIS Drama Festival- a festival which is a celebration of Languages. The society also organizes an annual play and arranges excursions to watch plays and other literary events in the city.</p>

                    <h1 className='font-semibold'>Fankaar</h1>

                    <p>This club is for students who wish to enhance their Urdu language skills, by organizing dramas, watching Urdu movies, holding sessions regarding diction and acting, reading Urdu monologues and newspapers, ultimately leading to participation in the Drama Festival.</p>


                    <h1 className='font-semibold'>Student Council</h1>


                    <p>The TIS Student Council provides a ‘platform for the student voice’ as per the TIS Mission Statement. Students are empowered to become involved in the affairs of the school, working in partnership with school management and staff for the benefit of the school and its students.</p>

                    <h1>Le Club Francophone</h1>

                    <p>Students will have access to French cultural activities at Alliance Française de Karachi. They may watch French movies, while mingling with new friends, native French speakers and Francophone from all over the world. They will participate in the Francophonie Festival and enjoy the “Fête de la Musique” to experience the rich style of live French Music, while developing their communication and social skills.</p>


                    <h1 className='font-semibold'>TIS Rowing Club</h1>


                    <p>This society is managed by those students interested in learning basic or advanced rowing for either recreation or national and international competitions.</p>


                    <h1 className='font-semibold'>TIS Sports Clubs</h1>


                    <p>TIS Sports Clubs promote a wide variety of athletics and is responsible for organizing in-house, as well as inter-school sporting activities. Sports include throw ball, basketball, cricket, badminton, field hockey, football, swimming and rugby. Students may also initiate sports events to raise funds for services.</p>



                    <h1 className='font-semibold'>Music Mania</h1>

                    <p>This club promotes singing, dancing and performing to music in English, Indian and Spanish and the production of musical plays in Urdu and English for the Drama Festival.</p>


                    <h1 className='font-semibold'>Changing the World One Bite at a Time</h1>


                    <p>Students take orders for baked goods in school and make home deliveries, thus raising money for an orphanage, to spread happiness to the world.</p>


                    <h1 className='font-semibold'>TIS Debatable</h1>


                    <p>TIS Debatable will discuss everything banned in class or at home. Students will bring their ideas, vote on a topic and debate on it.</p>

                    <h1 className='font-semibold'>Successful living</h1>


                    <p>Students will learn about mental health, while educating themselves and others. They will learn to look beyond the illness, strive to listen, understand and tell stories. This group will spread the word, raise awareness for mental health, illnesses and disorders that are often neglected in Pakistan, to make a difference.</p>

                    <h1 className='font-semibold'>Ejad-e-Hayan</h1>


                    <p>Ejad-e-Hayan enables students to critically think about, design and create their own scientific inventions and work in their field of interest.</p>


                </div>


            </section>

        </>
    )
}

export default SocietiesAndClub